// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import CaretDown from "@sc/XDL/Icons/CaretDown";
import { xBaseTheme } from "@sc/XDL/types";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            list: css`
                width: 100%;
                transform: translate(0, -3px); // remove the gap between the list and the input
                border: 1px solid ${color("common.ui9")};
                box-shadow: inset 0 1px 0 0 ${color("common.black", 0.1)};
                border-radius: 0 0 4px 4px;
            `,
            dropdownWrapper: css`
                && input[aria-expanded="true"] ~ ${IconWrapper} {
                    transform: rotate(180deg);
                }
            `,
        },
        iconProps: {
            color: "primary.main",
            src: CaretDown,
            height: 13,
            width: 9,
            css: css`
                &&&& {
                    background: transparent;
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
